import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function autoRetry<T>(
  fn: () => Promise<T>,
  retryCount: number = 3
): Promise<T> {
  return fn().catch((err) => {
    if (retryCount > 0) {
      return autoRetry(fn, retryCount - 1);
    }
    throw err;
  });
}
